'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getParticipants = require('../events/getParticipants');

var _getParticipants2 = _interopRequireDefault(_getParticipants);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = function (feis_id, eventId) {
  var fetchParticipants = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return function (dispatch) {
    dispatch({
      feis_id: feis_id,
      eventId: eventId,
      type: 'SET_CURRENT_STEWARDING_EVENT'
    });

    if (eventId && fetchParticipants) {
      return dispatch((0, _getParticipants2.default)(feis_id, eventId));
    }
  };
};


//////////////////
// WEBPACK FOOTER
// /Users/vidhigupta/isomorphic/lib/redux/actions/stages/setCurrentEvent.js
// module id = 160
// module chunks = 0